var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "d-flex align-center", attrs: { cols: _vm.cols } },
            [
              _c("canvas", { attrs: { id: _vm.id, height: "350" } }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "logo" },
                [
                  _c("v-img", {
                    attrs: {
                      src: require(`@/assets/img/${
                        _vm.$vuetify.theme.dark
                          ? "driblab_white.png"
                          : "driblab_color.png"
                      }`),
                      "max-width": "125px",
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }